import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { Paper, useTheme } from '@mui/material';
import BasicBreadcrumbs from '../Components/Breadcrumbs';
import { useLocation } from 'react-router-dom';

interface Props {
  window?: () => Window;
  collapsed?: boolean; // Add collapsed to the interface
  setCollapsed?: React.Dispatch<React.SetStateAction<boolean>>; // Add setCollapsed to the interface
}

export default function Layout(props: Props) {
  const { window } = props;
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const location = useLocation(); 

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header
        drawerWidth={theme.status.drawerWidth}
        mobileOpenBool={mobileOpen}
        setMobileToggle={(boolean: boolean) => {
          setMobileOpen(boolean);
        }}
        collapsed={collapsed} 
      />
      <Sidebar
        drawerWidth={theme.status.drawerWidth}
        mobileOpenBool={mobileOpen}
        setMobileToggle={(boolean: boolean) => {
          setMobileOpen(boolean);
        }}
        window={window}
        collapsed={collapsed} 
        setCollapsed={setCollapsed} 
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${collapsed ? 64 : theme.status.drawerWidth}px)`, xs: '100%' },
          marginTop: '30px', 
        }}
      >
        <Toolbar />
        {/* Conditionally render the breadcrumb */}
        {location.pathname !== '/' && (
          <Paper
            elevation={2}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.status.white,
              p: 1,
              mb: 3,
              marginTop: '-15px',
            }}
          >
            <BasicBreadcrumbs />
          </Paper>
        )}
        <Outlet />
      </Box>
    </Box>
  );
}